import SkillsPathsIcon from 'img/icons/skills-paths-icon.svg';
import {
  BodyRowType,
  HeaderIconConfig,
  IconLabel,
  IconType,
  OfferingTypeConfig,
} from '../utils/types';
import { formatProductRows } from '../BodyBuilder/utils';

const skillsPathIconConfig: HeaderIconConfig = {
  backgroundColor: '#5F526D',
  iconTitle: 'Delivery format: Skills Path',
  src: SkillsPathsIcon,
};

const skillsPathConfig: OfferingTypeConfig = {
  actionButtons: ({ isEnrolledSkillPath, learningPath, routerStore, t }) => {
    const routeName = 'skills-paths:view';
    const routeParams = { code: learningPath?.code, tab: 'offerings' };

    return {
      actionButtonA: {
        buttonLabel: isEnrolledSkillPath ? t('Continue') : t('View'),
        href: routerStore.router.buildUrl(routeName, routeParams),
        icon: IconType.Arrow,
        onClick: () => routerStore.navigate(routeName, routeParams),
      },
    };
  },
  bodyRowsLayout: ({ learningPath }) => {
    if (learningPath) {
      return [BodyRowType.Icons, BodyRowType.Custom];
    }
    return [BodyRowType.Icons];
  },
  buildCustomRows: ({ learningPath, offeringProducts }) => {
    if (learningPath) {
      return formatProductRows(offeringProducts);
    }
    return [];
  },
  headerConfig: ({ t }) => ({
    iconB: skillsPathIconConfig,
    title: t('Skills Path'),
  }),
  iconRowsLayout: () => [[IconLabel.Offerings]],
};

export default skillsPathConfig;
